import { render, staticRenderFns } from "./CurrencyNotAvailable.vue?vue&type=template&id=036d7879"
import script from "./CurrencyNotAvailable.vue?vue&type=script&lang=js"
export * from "./CurrencyNotAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports